import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import parseLinkHeader from '~/utils/parseLinkHeader';
import { catchRequestError } from '~/utils/request';

export const useListAllPaginated = (fetchParams = ref({})) => {
    const toasted = useToasted();
    const loading = ref(false);
    const list = ref([]);
    const error = ref();

    const fetchAll = async (fetchRequestFn) => {
        loading.value = true;
        list.value = [];
        error.value = '';

        try {
            let cursorLink = null;

            do {
                const response = await fetchRequestFn();
                const result = response.data.data;

                if (Array.isArray(result) && result.length) {
                    list.value.push(...result);
                }

                cursorLink = parseLinkHeader(response.headers?.link)?.next;
                fetchParams.value = {
                    ...fetchParams.value,
                    cursor: cursorLink?.cursor,
                };
            } while (cursorLink);
        } catch (e) {
            error.value = catchRequestError(e);
            toasted.error(error.value);
        } finally {
            loading.value = false;
        }
    };

    return {
        fetchAll,
        loading,
        list,
        error,
    };
};
